<div class="filter-label" *ngFor="let labelObj of activeFilters; trackBy: trackByFn" (click)="onRemoveLabel(labelObj)">
  <span class="filter-name mr-1" *ngIf="displayFilterName">{{ labelObj.title }}:</span>
  <span class="filter-value">{{ labelObj.label }}</span>
</div>
